import { QuoteBodyAccordion } from '../../../../components/Quotes/QuoteBodyAccordion';
import { QuotePageCustomer } from './QuotePageCustomer';

interface QuoteCustomizingPdfProps {
  value?: string;
  customizePdfFormDisabled: boolean;
  headerHeight?: number;
}

export const QuoteCustomizingPdf = ({
  value,
  customizePdfFormDisabled,
  headerHeight = 0,
}: QuoteCustomizingPdfProps) => {
  return (
    <QuoteBodyAccordion value={value} title="Preview Quote">
      {({ isExpanded }) =>
        isExpanded && (
          <QuotePageCustomer
            showQuoteInformation={false}
            showDownloadButton={false}
            isExternalView={false}
            customizePdfFormDisabled={customizePdfFormDisabled}
            headerHeight={headerHeight}
          />
        )
      }
    </QuoteBodyAccordion>
  );
};
